import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '../.';
import { MonthButton } from './CalendarPicker.styles';

interface CalendarHeaderProps {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
}

const CalendarHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
}: CalendarHeaderProps) => {
  const month = date.toLocaleString('en-us', { month: 'long' });
  const year = date.getFullYear();

  return (
    <Box horizontal justify="space-between" align="center" p="0 12px">
      <MonthButton onClick={decreaseMonth} dataName="decrease-month">
        <ChevronLeftIcon
          viewboxHeight={16}
          viewboxWidth={16}
          width={8}
          height={8}
        />
      </MonthButton>
      <Text color="secondaryText">
        {month} {year}
      </Text>
      <MonthButton onClick={increaseMonth} dataName="increase-month">
        <ChevronRightIcon
          viewboxHeight={16}
          viewboxWidth={16}
          width={8}
          height={8}
        />
      </MonthButton>
    </Box>
  );
};

export default CalendarHeader;
